import { FC } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import {
  Button,
  usePopoverDialog,
  useControlledField,
  Text,
  PopoverDialog,
  RadioField,
  Dot,
} from '@frontend/design-system';
import { taskCenterTrackingIds } from '../../tracking-ids';
import {
  filtersButtonStyle,
  filterSourceStyle,
  radioFieldStyle,
  rightIconStyle,
  selectedSourceStyle,
} from './common-styles';

interface TaskSourceFilterProps {
  source: TaskCenterTypes.TaskSource | '';
  setSource: (value: TaskCenterTypes.TaskSource) => void;
}

export const TaskSourceFilter: FC<TaskSourceFilterProps> = ({ source, setSource }) => {
  const { t } = useTranslation('task-center');
  const { getDialogProps, getTriggerProps } = usePopoverDialog();
  const sourceFiledProps = useControlledField({
    type: 'radio',
    value: source,
    onChange: (value) => setSource(value),
  });

  return (
    <span>
      <Button css={filtersButtonStyle} trackingId={taskCenterTrackingIds.filters.sourceFilter} {...getTriggerProps()}>
        <Icon name='cell-phone' size={16} color='default' />
        <Text weight='regular'>{t('Source')}</Text>
        {source && <Dot color='primary' css={selectedSourceStyle} />}
        <Icon name='alt-caret-right-tiny' color='subdued' css={rightIconStyle} />
      </Button>
      <PopoverDialog {...getDialogProps()} css={filterSourceStyle}>
        <RadioField name='' {...sourceFiledProps}>
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE}
            trackingId={taskCenterTrackingIds.filters.sourceCallIntelFilter}
          >
            {t('Call Intelligence')}
          </RadioField.Radio>
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_TASK_CENTER}
            trackingId={taskCenterTrackingIds.filters.sourceTaskCenterFilter}
          >
            {t('Task Center')}
          </RadioField.Radio>
          <RadioField.Radio
            value={TaskCenterTypes.TaskSource.SOURCE_MESSAGING}
            css={radioFieldStyle}
            trackingId={taskCenterTrackingIds.filters.sourceMessagingFilter}
          >
            {t('Messages')}
          </RadioField.Radio>
        </RadioField>
      </PopoverDialog>
    </span>
  );
};
